import { useState } from 'react'
import Image, { ImageProps } from 'next/image'
import Icon from 'shared/library/atoms/Icon'
import { generateCloudinaryUrl } from 'shared/helpers/generateCloudinaryUrl'
import styled from '@emotion/styled'

interface ProfileImageProps extends Omit<ImageProps, 'src'> {
  /**
   * An optional string to use as the image src. If the src is not provided,
   * a fallback image is rendered.
   */
  src?: string | null
  fallbackSize?: number
}

/**
 * Image component wrapper for next/image, which will fallback to a default
 * profile image icon, if the provided src is undefined, or fails to load.
 */
const ProfileImage = ({
  src,
  alt,
  fallbackSize = 24,
  ...other
}: ProfileImageProps) => {
  const [hasError, setHasError] = useState(false)

  return src && !hasError ? (
    <StyledImage
      {...other}
      fill
      src={generateCloudinaryUrl(src, 'profile')}
      alt={alt}
      onError={() => setHasError(true)}
    />
  ) : (
    <Icon name="user" size={fallbackSize} />
  )
}

const StyledImage = styled(Image)(({ theme }) => ({
  objectFit: 'cover',
  backgroundColor: theme.colors.white
}))

export default ProfileImage
